import React, { useState } from "react";
import { motion } from "framer-motion";

const testimonials = [
  {
    quote:
      "GoWave transformed our school's digital infrastructure with ClassScribe. The AI-powered grading and analytics have saved our teachers countless hours.",
    customerName: "Education Client",
    customerDesignation: "School Administrator",
    initials: "EC",
  },
  {
    quote:
      "The Hospital Management System they built is seamless. Patient records, billing, appointments — everything is automated and intelligent.",
    customerName: "Healthcare Client",
    customerDesignation: "Hospital Director",
    initials: "HC",
  },
  {
    quote:
      "Their custom software development process is incredibly efficient. From requirement to deployment, everything was handled professionally with AI-first thinking.",
    customerName: "Enterprise Client",
    customerDesignation: "CTO, Tech Startup",
    initials: "ET",
  },
];

function TestimonialComponent() {
  const [current, setCurrent] = useState(0);

  const next = () => setCurrent((prev) => (prev + 1) % testimonials.length);
  const prev = () =>
    setCurrent(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );

  return (
    <div className="testimonial-section-new">
      <div className="container">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="section-badge">Testimonials</div>
          <h3>
            What Our <span style={{ color: "#63FFCD" }}>Clients</span> Say
          </h3>
        </motion.div>

        <div className="testimonial-carousel-new">
          <button className="testimonial-nav prev" onClick={prev}>
            <span className="fa fa-chevron-left"></span>
          </button>

          <motion.div
            key={current}
            className="testimonial-card-new"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4 }}
          >
            <div className="testimonial-quote-icon">
              <span className="fa fa-quote-left"></span>
            </div>
            <blockquote className="testimonial-text-new">
              {testimonials[current].quote}
            </blockquote>
            <div className="testimonial-author-new">
              <div className="testimonial-avatar-new">
                {testimonials[current].initials}
              </div>
              <div>
                <h5 className="testimonial-name-new">
                  {testimonials[current].customerName}
                </h5>
                <p className="testimonial-role-new">
                  {testimonials[current].customerDesignation}
                </p>
              </div>
            </div>
          </motion.div>

          <button className="testimonial-nav next" onClick={next}>
            <span className="fa fa-chevron-right"></span>
          </button>
        </div>

        <div className="testimonial-dots">
          {testimonials.map((_, i) => (
            <button
              key={i}
              className={`testimonial-dot ${i === current ? "dot-active" : ""}`}
              onClick={() => setCurrent(i)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default TestimonialComponent;
